import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr'

const companyOrganizationsApi = createAggrApiInstance(aggr.CompanyOrganizationsApi)

export const queryAllOrganization = async (reqData: aggr.OrganizationQueryAllRq) => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsQueryall(reqData))
  return res
}

export const querySubtotal = async (reqData: aggr.OrganizationQuerySubtotalRq) => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsQuerysubtotal(reqData))
  return res
}

export const queryOrganizationDetail = async (companyUuid: string) => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsQuerydetail(companyUuid))
  return res
}

export const queryOrganizationData = async (companyOrgUuid: string) => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsQuery(companyOrgUuid))
  return res
}

export const createCompanyOrganization = async (reqData: aggr.OrganizationUpdateRq) => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsCreate(reqData))
  return res
}

export const updateCompanyOrganization = async (reqData: aggr.OrganizationUpdateRq) => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsUpdate(reqData))
  return res
}

export const removeCompanyOrganization = async (companyOrganizationUuidList: string[]) => {
  const req: aggr.OrganizationDeleteRq = {
    companyOrganizationUuidList: companyOrganizationUuidList
  }
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsDelete(req))
  return res
}

export const queryOrganizationMembers = async (reqData: aggr.OrganizationQueryMembersRq) => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsQuerymembers(reqData))
  return res
}

export const queryMembers = async (reqData: aggr.OrganizationQueryMembersRq) => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsQuerymembers(reqData))
  return res
}

export const updateMemberPermission = async (reqData: aggr.OrganizationUpdateMemberPermissionRq) => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsUpdatememberpermission(reqData))
  return res
}

export const sendRegistrationInvitation = async (reqData: aggr.OrganizationSendRegistrationInvitationRq) => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsSendregistrationinvitation(reqData))
  return res
}

export const deleteMember = async (reqData: aggr.OrganizationDeleteMemberRq) => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsDeletemember(reqData))
  return res
}

export const exportAll = async (reqData: aggr.OrganizationExportAllRq) => {
  const res = await handleApiStatus<any>(() => companyOrganizationsApi.organizationsExportall(reqData))
  return res
}

export const exportSelected = async (reqData: aggr.OrganizationExportSelectedRq) => {
  const res = await handleApiStatus<any>(() => companyOrganizationsApi.organizationsExportselected(reqData))
  return res
}

export const getCompanyDomainOption = async (companyUuid: string) => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsGetcompanydomainoption(companyUuid))
  return res
}

export const getGAProjects = async () => {
  const res = await handleApiStatus(() => companyOrganizationsApi.organizationsQuerygaprojects())
  return res
}
